<template>
  <div class="form-wrapper" :class="[requestSent && !loading && !success ? '--error-msg' : '']">
    <transition name="error">
      <error v-if="requestSent && !loading && !success" :icon="iconNO"></error>
    </transition>
    <a v-if="requestSent && !loading && !success && !unverified" class="form-wrapper__try-again-message" @click="tryAgain">
      <!-- when wrong credentials is given, this message will pop up -->
      Invalid user/password combination, Try Again.
    </a>
    <p v-if="requestSent && !loading && unverified" class="form-wrapper">
      You can proceed forward only after you verify your account. To verify your account, please check your email and click on the link.
    </p>

    <button v-if="requestSent && !loading && unverified" :class="isMobile ? 'loginform__button' : 'loginform__button--website'" @click="handleResendEmail">Click here to resend.</button>

    <loading v-if="loading"> </loading>
    <!-- <loading v-if="loading && !success">
    </loading> -->
    <!-- <div v-if="loading" class="spinner-border spinner-class"></div> -->
    <transition name="success">
      <success v-if="requestSent && !loading && success"></success>
    </transition>
    <div v-if="!requestSent && !loading">
      <img src="../../assets/dovemed-logo-footer.png" class="mb-4 l-show-in-mobile m-mt-5" />
      <h2 class="form-wrapper__title mt-5 m-mt-0" v-show="!signup">Welcome Back</h2>
      <h2 class="form-wrapper__title m-mt-100" v-show="signup">Let’s get started</h2>
      <p class="login-message" id="login-msg" v-show="!signup">Login to your account to stay connected with us and access all the great features DoveMed has to offer.</p>
      <p class="login-message" id="signup-msg" v-show="signup">
        Create an account to access all the great features DoveMed has to offer.
        <br />
        It takes less than 30 seconds to do so.
      </p>
      <div class="form-wrapper__social">
        <social-login :socialLabel="signup ? 'Sign up with:' : 'Log in with:'"></social-login>
      </div>
      <horizontal-line-with-text-inside text="Or"> </horizontal-line-with-text-inside>
      <div class="form-wrapper__form">
        <form @submit.prevent="submit(signup ? 'REGISTER' : 'LOGIN')" method="post" class="loginform">
          <div class="loginform__login w-100">
            <div class="loginform__form-field">
              <label class="fw700">Email Address</label>
              <input
                id="email-register"
                class="loginform__input gray900"
                :class="{ '--error': submitted && (errors.has('email') || emailAlreadyExists) }"
                name="email"
                v-validate="'email|required'"
                v-model="form.username"
                placeholder="Email"
                type="text"
              />
            </div>
            <p class="small-text--error small-text--left" v-if="submitted && errors.has('email')">
              {{ errors.first("email") }}
            </p>
            <p class="small-text--error small-text--left" v-if="emailAlreadyExists">
              This email already exists
            </p>
          </div>
          <div class="loginform__password w-100">
            <label for="password" class="fw700">Password</label>
            <a-input-password
              id="user-password"
              class="loginform__pass gray900"
              :class="{ '--error': submitted && errors.has('password') }"
              name="password"
              v-model="form.password"
              v-validate="`required${signup ? '|min:6|verify_password' : ''}`"
              placeholder="Password"
              type="password"
              ref="password"
              vid="password"
            />
            <!-- v-validate="'required'" -->
            <p v-if="submitted && errors.has('password') && signup" class="small-text--error small-text--left">
              {{ errors.first("password") }}
            </p>
            <div class="forgot-password" v-show="!signup">
              <a :href="url.passwordReset">Forgot Password?</a>
            </div>
            <template v-if="signup">
              <!-- <div class="loginform__password w-100" v-if="signup"> -->
              <label for="passwordConfirmation" class="fw700 mt10"> Password Confirmation </label>
              <a-input-password
                id="user-password-confirmation"
                class="loginform__pass gray900"
                :class="{ '--error': submitted && errors.has('password_confirmation') }"
                name="password_confirmation"
                v-model="form.confirmPassword"
                v-validate="'required|confirmed:password'"
                placeholder="Confirm Password"
                type="password"
                data-vv-as="password"
              />
              <!-- ref="password" -->
              <p v-if="submitted && errors.has('password_confirmation')" class="small-text--error small-text--left">
                {{ errors.first("password_confirmation") }}
              </p>
              <div class="forgot-password" v-show="!signup">
                <a :href="url.passwordReset">Forgot Password?</a>
              </div>
            </template>
          </div>
          <!-- <a-select
            show-search
            :size="'large'"
            class="w-100"
            placeholder="Search Symptom"
            style="width: 539px"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
          >
            <a-select-option
              v-for="(item, key) in [{id: 1, display_name: 'test'}]"
              :value="item.display_name"
            >
              {{item.display_name}}
            </a-select-option>
          </a-select> -->
          <div class="loginform__terms" v-show="signup">
            <input type="checkbox" v-model="isTermsAccepted" />
            <span class="loginform__terms__terms-text">
              I agree with <a :href="`/help-center/faq/mycircles-terms-of-use`" target="_blank">Terms of Use</a> and <a :href="`/help-center/faq/mycircles-privacy-policy`" target="_blank">Privacy Policy</a>
              <!-- I agree with <a :href="`${SSO_BASE_URL}/about-us/terms-conditions/`" target="_blank">Terms of Use</a> and <a :href="`${SSO_BASE_URL}/privacy-policy/`" target="_blank">Privacy Policy</a> -->
            </span>
          </div>
          <div class="loginform__allow-emails" v-show="signup">
            <input type="checkbox" class="cb2" />
            <span class="loginform__allow-emails__text"> Allow occasional emails about new feautures and updates </span>
          </div>
          <!-- <div class="loginform__forgot-password">
            <p>
              <input type="checkbox" />
              <span class="ml-1">Keep me logged in</span>
            </p>
          </div> -->

          <!-- <div class="loginform__login-button-wrapper">
            <privacy-policy></privacy-policy>
          </div> -->
          <button
            id="login-button"
            :class="isMobile ? 'loginform__button' : signup ? (isTermsAccepted ? 'loginform__button--website' : 'loginform__button--website loginform__disabled') : 'loginform__button--website'"
            type="submit"
            :style="{ border: 'none', width: '100%' }"
          >
            <!-- && form.username && form.password && form.password === form.confirmPassword -->
            {{ signup ? "Sign Up" : "Log In" }}
          </button>
          <div class="loginform__login-button-wrapper" v-show="!signup">
            <privacy-policy></privacy-policy>
          </div>
          <div class="loginform__signup-wrapper pb-5 mb-5">
            <span class="signup-message" id="signup-msg" v-show="signup"> Already have an account? </span>
            <span class="signup-message" id="login-msg" v-show="!signup"> Don’t have an account? </span>
            <div class="signup-button" @click="toggleOption">
              {{ signup ? "Log In" : "Sign Up" }}
            </div>
          </div>
        </form>
      </div>
      <!-- <div class="toggle-switch" @click="toggleOption">
        Don't have an account yet?
        <span
          :style="{
            color: '#0f74bd',
            'font-size': '18px',
            'font-weight': 'bold',
            'margin-left': '8px',
          }"
        >
          SIGNUP
        </span>
      </div> -->
    </div>
  </div>
</template>

<script>
import PrivacyPolicy from "./info/privacy-policy"
import Form from "./utils/form.js"
import SocialLogin from "./social-login"
import Error from "./info/statuses/error"
import Loading from "./info/statuses/loading"
import Success from "./info/statuses/success"
import HorizontalLineWithTextInside from "./horizontal-line-with-text-inside"
import Login from "./utils/login"
import { AUTH_URLS } from "./utils/constants"
import { mapGetters } from "vuex"
import axios from "axios"
import { ref } from "vue"

export default {
  name: "login-form",
  mixins: [Login, Form],
  props: { signup: Boolean },
  components: {
    PrivacyPolicy,
    SocialLogin,
    HorizontalLineWithTextInside,
    Error,
    Loading,
    Success,
  },
  data: function() {
    return {
      url: AUTH_URLS,
      form: {
        username: "",
        password: "",
        confirmPassword: "",
      },
      type: null,
      signUp: false,
      // signUp: null,
      submitted: false,
      signUpSet: false,
      isTermsAccepted: false,
    }
  },

  computed: {
    ...mapGetters({
      isSignUp: "SsoLogin/isSignUp",
      isSignUpSet: "SsoLogin/isSignUpSet",
    }),
  },

  watch: {
    unverified: function(val, old) {
      // if (val) {
      const payload = { email: this.email, isVisible: val }
      this.$store.commit("App/setMail", payload)
      // }
    },
  },
  methods: {
    setValues: function() {
      return {
        username: "",
        password: "",
        confirmPassword: "",
      }
    },

    toggleOption() {
      // this.signUp = !this.signUp;
      // console.log("1 toggleOption isSignUp ->", this.isSignUp);
      // console.log("1 toggleOption big signUp ->", this.signUp);
      // console.log("1 toggleOption small signup ->", this.signup);
      this.$store.commit("SsoLogin/setSignUp", !this.isSignUp)
      this.signUp = this.isSignUp
      this.submitted = false
      // console.log("2 toggleOption isSignUp ->", this.isSignUp);
      // console.log("2 toggleOption big signUp ->", this.signUp);
      setTimeout(() => {
        // this.signUp ? (this.signUpSet = true) : (this.signUpSet = false);
        this.isSignUp ? this.$store.commit("SsoLogin/setSignUpSet", true) : this.$store.commit("SsoLogin/setSignUpSet", false)
        this.signUpSet = this.isSignUpSet
        // console.log("2 toggleOption small signup ->", this.signup);
      }, 100)
    },

    handleResendEmail() {
      if (this.email) {
        axios
          .post(`${process.env.SSO_BASE_URL}/api/v1/signupresend/`, { email: this.email })
          .then(res => {})
          .catch(err => {
            console.log(err)
          })
      }
    },
  },
}
</script>

<style lang="scss">
.error-enter-active {
  animation: error-in 0.5s;
}

@keyframes error-in {
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}

.success-enter-active {
  animation: success-in 0.5s;
}

@keyframes success-in {
  from {
    width: 80px;
    height: 80px !important;
    border-radius: 50%;
  }
  to {
    width: 200px;
    height: 80px;
    border-radius: 10%;
  }
}

.form-wrapper {
  display: flex;
  justify-content: center;
  .login-message {
    font-size: 16px;
    font-weight: 400;
    color: #647490;
  }
  &.--error-msg {
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  &__try-again-message {
    cursor: pointer;
    margin-top: 1rem;
  }

  .loginform {
    a {
      // color: #0f74bd !important;
      color: #2a71d4 !important;
    }

    &__form-field {
      // margin: 24px 0;
      margin: 10px 0;
      input {
        &::placeholder {
          color: #94a3b8;
          font-size: 16px;
        }
      }
    }

    &__input {
      // margin-top: 1rem;
      padding: 10px;
      height: 45px;
      width: 100%;
      border: 1px solid #dddddd;
      background-color: #ffffff;
      border-radius: 4px;
    }

    &__password {
      // position: relative;
      // margin: 24px 0;
      margin-bottom: 10px;
    }

    .ant-input-suffix {
      cursor: pointer;
    }

    &__pass {
      border-radius: 4px;
      height: 45px;
      width: 100%;
      background-color: #ffffff;
    }

    &__terms {
      display: flex;
      align-items: center;
      // margin: 24px 0;
      margin-top: 20px;
      height: 18px;
      &__terms-text {
        margin: 0 8px;
        font-size: 14px;
        font-weight: 400;
      }
    }

    &__allow-emails {
      display: flex;
      align-items: center;
      margin: 10px 0 20px 0;
      height: 18px;
      &__text {
        margin: 0 8px;
        font-size: 14px;
        font-weight: 400;
      }
    }

    .forgot-password {
      display: flex;
      justify-content: flex-end;
      padding: 10px 0;
      a {
        font-size: 14px;
        color: #2a71d4 !important;
        font-weight: 700;
        font-family: "Lato";
        // position: absolute;
        // right: 0;
        // top: 80px;
        &:hover {
          text-decoration: none;
        }
      }
    }

    // .forgot-password{
    //     position: absolute;
    //     right: 0;
    //     bottom: 0;
    //     top: 20px;

    // }

    &__button {
      height: 45px;
      // width: 350px;
      // background-color: #0f74bd;
      background-color: #2a71d4;
      color: white;
      // border-radius: 35px;
      border-radius: 6px;

      &--website {
        height: 45px;
        // width: 581px;
        background-color: #2a71d4;
        color: white;
        border-radius: 6px;
        // position: fixed;
        // bottom: 3.5rem;
        // right: 0;
        // left: 0;
        margin: 0 auto;
      }
    }

    &__disabled {
      opacity: 0.5;
    }
    &__forgot-password {
      display: flex;
      font-size: 12px;
      justify-content: flex-end;
      width: 100%;
      margin-top: 0.5rem;
      p {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .small-text {
      &--error {
        color: red;
        font-size: 12px;
        margin: 5px;
      }
      &--left {
        text-align: left;
      }
    }

    &__login-button-wrapper {
      margin-top: 24px;
    }

    &__signup-wrapper {
      margin: 20px 0;
      // margin: 48px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .signup-message {
        color: #1e2945;
        font-size: 16px;
        font-family: "Lato";
      }
      .signup-button {
        cursor: pointer;
        margin: 0 24px;
        background: #2a71d4;
        border-radius: 6px;
        padding: 8px 27px;
        color: #ffffff;
        @media screen and (max-width: 600px) {
          padding: 8px 16px;
          // margin: 0 12px;
          margin-right: 0 !important;
        }
      }
    }
  }

  .--error {
    border: 1px solid red;
  }

  &__form {
    width: 100%;
    margin-top: 24px;
  }
  &__forgot-password {
    display: flex;
    font-size: 12px;
    justify-content: space-between;
    width: 100%;
    margin-top: 0.5rem;
    p {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__title {
    color: #333333;
    font-size: 36px;
    font-weight: bold;
  }
  &__button {
    height: 45px;
    width: 350px;
    // background-color: #0f74bd;
    background-color: #2a71d4;
    color: white;
    border-radius: 35px;
  }
}
.loginform__allow-emails {
  @media screen and (max-width: 600px) {
    margin-top: 20px !important;
  }
}
.cb2 {
  @media screen and (max-width: 600px) {
    // width: 14.66px;
    aspect-ratio: 1;
  }
}
.l-show-in-mobile {
  display: none !important;
  @media screen and (max-width: 900px) {
    display: block !important;
  }
}
@media screen and (max-width: 900px) {
  .m-mt-0 {
    margin-top: 0 !important;
  }
  .m-mt-5 {
    margin-top: 3rem !important;
  }
}
.m-mt-100 {
  @media screen and (max-width: 600px) {
    margin-top: 24px !important;
    // margin-top: 50px !important;
    // margin-top: 100px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-form.vue